module.exports = __webpack_public_path__ + "static/media/half-circle_white.5c513ff2.png";